import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import HRLoginPage from './pages/HRLoginPage';
import CourseLoginPage from './pages/CourseLoginPage';
import SaaSLoginPage from './pages/SaaSLoginPage';
import LoginOptionsPage from './pages/LoginOptionsPage';
import SuperAdminLoginPage from './pages/SuperAdminLoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import JobsPage from './pages/JobsPage';
import AboutPage from './pages/AboutPage';
import PricingPage from './pages/PricingPage';
import JobDetailsPage from './pages/JobDetailsPage';
import TemplatesPage from './pages/TemplatesPage';
import ResumeBuilderPage from './pages/ResumeBuilderPage';
import ProfilePage from './pages/ProfilePage';
import OnboardingPage from './pages/OnboardingPage';
import ProfileSetupPage from './pages/ProfileSetupPage';
import CandidateProfileViewPage from './pages/CandidateProfileViewPage';
import EnhanceResumePage from './pages/EnhanceResumePage';
import CreateResumePage from './pages/CreateResumePage';
import EnhanceCVLandingPage from './pages/EnhanceCVLandingPage';
import CoursesPage from './pages/CoursesPage';
import AllCoursesPage from './pages/AllCoursesPage';
import MarketplacePage from './pages/MarketplacePage';
import HrDashboardPage from './pages/HrDashboardPage';
import HrLiveInterviewReportPage from './pages/HrLiveInterviewReportPage';
import MyApplicationsPage from './pages/MyApplicationsPage';
import MatchResultPage from './pages/MatchResultPage';
import AssessmentWelcomePage from './pages/AssessmentWelcomePage';
import AssessmentDeviceCheckPage from './pages/AssessmentDeviceCheckPage';
import AssessmentInterviewPage from './pages/AssessmentInterviewPage';
import AssessmentCompletePage from './pages/AssessmentCompletePage';
import HrInterviewDashboard from './pages/HrInterviewDashboard';
import InterviewReportPage from './pages/InterviewReportPage';
import InterviewReviewPage from './pages/InterviewReviewPage';
import CourseDetailPage from './pages/CourseDetailPage';
import CourseBillingPage from './pages/CourseBillingPage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import CourseProviderDashboard from './pages/CourseProviderDashboard';
import SaaSProviderDashboard from './pages/SaaSProviderDashboard';
import DataAnalysisDashboard from './pages/DataAnalysisDashboard';
import AITrainerPage from './pages/AITrainerPageRedesigned';
import AITrainerLandingPage from './pages/AITrainerLandingPage';
import AITrainerSetupPage from './pages/AITrainerSetupPage';
import AITrainerSessionPage from './pages/AITrainerSessionPage';
import MyReportsPage from './pages/MyReportsPage';
import MyCoursesPage from './pages/MyCoursesPage';
import LiveInterviewPage from './pages/LiveInterviewPage';
import LiveInterviewWelcomePage from './pages/LiveInterviewWelcomePage';
import LiveInterviewDeviceCheckPage from './pages/LiveInterviewDeviceCheckPage';
import LiveInterviewSessionPage from './pages/LiveInterviewSessionPage';
import LiveAITrainerPage from './pages/LiveAITrainerPage';
import LiveInterviewCompletePage from './pages/LiveInterviewCompletePage';
import TrainingReportPage from './pages/TrainingReportPage';
import LinkedInCallbackPage from './pages/LinkedInCallbackPage';
import HrCandidatesPage from './pages/HrCandidatesPage';
import HrProfileSettingsPage from './pages/HrProfileSettingsPage';
import HrCandidateProfilePage from './pages/HrCandidateProfilePage';
import HrJobsPage from './pages/HrJobsPage';
import HrApplicationsPage from './pages/HrApplicationsPage';
import HrDocumentVerificationPage from './pages/HrDocumentVerificationPage';
import DocumentUploadPage from './pages/DocumentUploadPage';
import HrAnalyticsPage from './pages/HrAnalyticsPage';
import HrMessagesPage from './pages/HrMessagesPage';
import HrSettingsPage from './pages/HrSettingsPage';
import VerificationWelcomePage from './pages/VerificationWelcomePage';
import VerificationAssessmentPage from './pages/VerificationAssessmentPage';
import VerificationCompletePage from './pages/VerificationCompletePage';
import SuperAdminVerificationDashboard from './pages/SuperAdminVerificationDashboard';
import RecruiterLandingPage from './pages/RecruiterLandingPage';
import PlacementTrainingLandingPage from './pages/PlacementTrainingLandingPage';
import CourseTeachingPage from './pages/CourseTeachingPage';
import CourseTeachingReportPage from './pages/CourseTeachingReportPage';
import CoursePreviewPage from './pages/CoursePreviewPage';
import PaymentPage from './pages/PaymentPage';
import SuperAdminPaymentManagement from './pages/SuperAdminPaymentManagement';
import SuperAdminPaymentOrders from './pages/SuperAdminPaymentOrders';
import SuperAdminPaymentWebhooks from './pages/SuperAdminPaymentWebhooks';
import CandidateDashboard from './pages/CandidateDashboard';
import CandidateProfilePage from './pages/CandidateProfilePage';
import CandidateApplicationsPage from './pages/CandidateApplicationsPage';
import CandidateCoursesPage from './pages/CandidateCoursesPage';
import CourseProgressPage from './pages/CourseProgressPage';
import CandidateReportsPage from './pages/CandidateReportsPage';
import CandidateTransactionsPage from './pages/CandidateTransactionsPage';
import CandidateSettingsPage from './pages/CandidateSettingsPage';
import CandidateProfileEditPage from './pages/CandidateProfileEditPage';
import PlacementTrainingPage from './pages/PlacementTrainingPage';
import CandidatePlacementTrainingDashboard from './pages/CandidatePlacementTrainingDashboard';
import PlacementCompanyPage from './pages/PlacementCompanyPage';
import PlacementJobDetailsPage from './pages/PlacementJobDetailsPage';
import StudentPackagesPage from './pages/StudentPackagesPage';
import SuperAdminPackageManagement from './pages/SuperAdminPackageManagement';
import PlacementAptitudeTestPage from './pages/PlacementAptitudeTestPage';
import PlacementCodingTestPage from './pages/PlacementCodingTestPage';
import PlacementTechInterviewPage from './pages/PlacementTechInterviewPage';
import PlacementHRInterviewPage from './pages/PlacementHRInterviewPage';
import PlacementResultsPage from './pages/PlacementResultsPage';
import PlacementCertificatePage from './pages/PlacementCertificatePage';
import SupportPage from './pages/SupportPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/recruiter" element={<RecruiterLandingPage />} />
        <Route path="/placement-training-landing" element={<PlacementTrainingLandingPage />} />
        
        {/* Placement Training Routes */}
        <Route path="/placement-training" element={<PlacementTrainingPage />} />
        <Route path="/placement-training/company/:companyId" element={<PlacementCompanyPage />} />
        <Route path="/placement-training/position/:positionId" element={<PlacementJobDetailsPage />} />
        <Route path="/placement-training/assessment/:assessmentId/aptitude" element={<PlacementAptitudeTestPage />} />
        <Route path="/placement-training/assessment/:assessmentId/coding" element={<PlacementCodingTestPage />} />
        <Route path="/placement-training/assessment/:assessmentId/tech-interview" element={<PlacementTechInterviewPage />} />
        <Route path="/placement-training/assessment/:assessmentId/hr-interview" element={<PlacementHRInterviewPage />} />
        <Route path="/placement-training/assessment/:assessmentId/results" element={<PlacementResultsPage />} />
        <Route path="/placement-training/certificate/:certificateId" element={<PlacementCertificatePage />} />
        
        <Route path="/super-admin/dashboard" element={<SuperAdminDashboard />} />
        <Route path="/super-admin/data-analysis" element={<DataAnalysisDashboard />} />
        <Route path="/super-admin/verification" element={<SuperAdminVerificationDashboard />} />
        <Route path="/super-admin/verification/candidates" element={<SuperAdminVerificationDashboard />} />
        <Route path="/super-admin/verification/settings" element={<SuperAdminVerificationDashboard />} />
        <Route path="/super-admin/payments" element={<SuperAdminPaymentManagement />} />
        <Route path="/super-admin/payments/orders" element={<SuperAdminPaymentOrders />} />
        <Route path="/super-admin/payments/webhooks" element={<SuperAdminPaymentWebhooks />} />
        <Route path="/super-admin/packages" element={<SuperAdminPackageManagement />} />
        <Route path="/course-provider/dashboard" element={<CourseProviderDashboard />} />
        <Route path="/saas-provider/dashboard" element={<SaaSProviderDashboard />} />
        <Route path="/hr/dashboard" element={<HrDashboardPage />} />
        <Route path="/hr/jobs" element={<HrJobsPage />} />
        <Route path="/hr/applications" element={<HrApplicationsPage />} />
        <Route path="/hr/document-verification" element={<HrDocumentVerificationPage />} />
        <Route path="/document-upload" element={<DocumentUploadPage />} />
        <Route path="/hr/candidates" element={<HrCandidatesPage />} />
        <Route path="/hr/interviews" element={<HrInterviewDashboard />} />
        <Route path="/hr/analytics" element={<HrAnalyticsPage />} />
        <Route path="/hr/messages" element={<HrMessagesPage />} />
        <Route path="/hr/settings" element={<HrSettingsPage />} />
        <Route path="/hr/candidate-profile/:candidateId" element={<HrCandidateProfilePage />} />
        <Route path="/hr/profile-settings" element={<HrProfileSettingsPage />} />
        <Route path="/hr/interview-report/:interviewId" element={<InterviewReportPage />} />
        <Route path="/hr/interview-review/:interviewId" element={<InterviewReviewPage />} />
        <Route path="/hr/live-interview-report/:sessionId" element={<HrLiveInterviewReportPage />} />
        <Route path="/landing" element={<LandingPage />} />
        
        {/* New Candidate Dashboard Routes* */}
        <Route path="/candidate/dashboard" element={<CandidateDashboard />} />
        <Route path="/candidate/profile" element={<CandidateProfilePage />} />
        <Route path="/candidate/profile/edit" element={<CandidateProfileEditPage />} />
        <Route path="/candidate/applications" element={<CandidateApplicationsPage />} />
        <Route path="/candidate/courses" element={<CandidateCoursesPage />} />
        <Route path="/candidate/courses/:courseId/progress" element={<CourseProgressPage />} />
        <Route path="/candidate/reports" element={<CandidateReportsPage />} />
        <Route path="/candidate/transactions" element={<CandidateTransactionsPage />} />
        <Route path="/candidate/settings" element={<CandidateSettingsPage />} />
        <Route path="/candidate/packages" element={<StudentPackagesPage />} />
        <Route path="/candidate/placement-training" element={<CandidatePlacementTrainingDashboard />} />
        
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/all-courses" element={<AllCoursesPage />} />
        <Route path="/courses/:id" element={<CourseDetailPage />} />
        <Route path="/course-billing/:id" element={<CourseBillingPage />} />
        <Route path="/course-preview" element={<CoursePreviewPage />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route path="/hr" element={<HrDashboardPage />} />
        
        {/* Login Routes */}
        <Route path="/login-options" element={<LoginOptionsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/hr_login" element={<HRLoginPage />} />
        <Route path="/course_login" element={<CourseLoginPage />} />
        <Route path="/saas_login" element={<SaaSLoginPage />} />
        <Route path="/superadmin_login" element={<SuperAdminLoginPage />} />
        
        {/* OAuth Callback Routes */}
        <Route path="/auth/linkedin/callback" element={<LinkedInCallbackPage />} />
        
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/jobs/:id" element={<JobDetailsPage />} />
        <Route path="/match-result" element={<MatchResultPage />} />
        <Route path="/assessment/welcome" element={<AssessmentWelcomePage />} />
        <Route path="/assessment/device-check" element={<AssessmentDeviceCheckPage />} />
        <Route path="/assessment/interview" element={<AssessmentInterviewPage />} />
        <Route path="/assessment/complete" element={<AssessmentCompletePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/terms" element={<TermsAndConditionsPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/resume-builder" element={<ResumeBuilderPage />} />
        <Route path="/profile" element={<ProfilePage key="profile" />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/profile/setup" element={<ProfileSetupPage />} />
        <Route path="/profile/view" element={<CandidateProfileViewPage />} />
        <Route path="/enhance-cv" element={<EnhanceCVLandingPage />} />
        <Route path="/enhance-cv/improve" element={<EnhanceResumePage />} />
        <Route path="/enhance-cv/create" element={<EnhanceResumePage />} />
        <Route path="/enhance-resume" element={<EnhanceResumePage />} />
        <Route path="/create-resume" element={<CreateResumePage />} />
        <Route path="/upload-resume" element={<ProfilePage />} />
        <Route path="/applications" element={<MyApplicationsPage />} />
        <Route path="/my-reports" element={<MyReportsPage />} />
        <Route path="/my-courses" element={<MyCoursesPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/ai-trainer" element={<AITrainerLandingPage />} />
        <Route path="/ai-trainer/configure" element={<AITrainerPage />} />
        <Route path="/ai-trainer/welcome" element={<AITrainerSetupPage />} />
        <Route path="/ai-trainer/camera-check" element={<AITrainerSetupPage />} />
        <Route path="/ai-trainer/mic-check" element={<AITrainerSetupPage />} />
        <Route path="/ai-trainer/session" element={<AITrainerSessionPage />} />
        <Route path="/live-ai-trainer" element={<LiveAITrainerPage />} />
        <Route path="/live-interview/welcome" element={<LiveInterviewWelcomePage />} />
        <Route path="/live-interview/device-check" element={<LiveInterviewDeviceCheckPage />} />
        <Route path="/live-interview/:applicationId" element={<LiveInterviewSessionPage />} />
        <Route path="/live-interview-complete" element={<LiveInterviewCompletePage />} />
        <Route path="/training-report" element={<TrainingReportPage />} />
        <Route path="/verification-welcome" element={<VerificationWelcomePage />} />
        <Route path="/verification-assessment" element={<VerificationAssessmentPage />} />
        <Route path="/verification-complete" element={<VerificationCompletePage />} />
        
        {/* Course Teaching Routes */}
        <Route path="/course/:courseId/module/:moduleId/teach" element={<CourseTeachingPage />} />
        <Route path="/course-teaching/report/:sessionId" element={<CourseTeachingReportPage />} />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;

